import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import {
  setNihPositiveStrokeScaleScoreMap,
  setRaceStrokeScaleScoreMap,
  setStrokeScaleScoreTotal,
  setVitalsStrokeScaleValues,
  setStrokeScaleScoreTotalPNNV,
  setStrokeScaleScoreTotalPNNVEnabled,
} from '../store/vitals.actions'

export function* setStrokeScale() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const { strokeScale, strokeScoreFlag } = patientVital
  patientVital.strokeScale = strokeScale
  patientVital.strokeScoreFlag = strokeScoreFlag
  yield put(setStrokeScaleScoreTotal(null))
  yield put(setNihPositiveStrokeScaleScoreMap(new Map()))
  yield put(setRaceStrokeScaleScoreMap(new Map()))
  yield put(setVitalsStrokeScaleValues([]))
  yield put(setStrokeScaleScoreTotalPNNV(null))
  yield put(setStrokeScaleScoreTotalPNNVEnabled(false))
}
export function* setStrokeScaleSaga() {
  yield takeLatest([VitalsConstants.SET_STROKE_SCALE], setStrokeScale)
}
